var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./SellBuyArticle.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-b090d8e6!../../node_modules/vue-loader/lib/selector?type=template&index=0!./SellBuyArticle.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/SellBuyArticle.vue
// module id = 708
// module chunks = 0